import { call, select, takeLatest } from '@redux-saga/core/effects'
import { put } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { OptionsService } from '../services/options.service'
import { setCustomFluidsOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getCustomFluidsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const customFluidsOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getCustomFluidsOptions,
    ])
    const { entity } = customFluidsOptionsResponse
    yield put(setCustomFluidsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCustomFluidsOptions() error: ${e}`))
  }
}

export function* getCustomFluidsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCustomFluidsOptions)
}
